<template>
  <div class="loading-screen" v-if="loading">
    <div class="loading"></div>
    <div class="message">{{ loading }}</div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'loadingScreen',
    props: [],
    data () {
      return {}
    },
    computed: {
      ...mapState('destiny', ['loading'])
    },
    methods: {},
    components: {}
  }
</script>

<style lang="scss">
  @import "../styles/settings";
  .loading-screen {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 100;


    background: rgba($background, .7);
    .loading {
      text-align: center;
      border-top: 4px solid rgba(255, 255, 255, 0);
      border-right: 4px solid rgba(255, 255, 255, .2);
      border-bottom: 4px solid rgba(255, 255, 255, .4);
      border-left: 4px solid rgba(255, 255, 255, .8);
      border-radius: 50%;
      width: 3rem;
      height: 3rem;
      animation: spin 2s linear infinite;

      display: block;
      margin: 3rem auto;
    }

    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
    .message {
      font-size: 2rem;
      text-shadow: $default-text-shadow;
      font-weight: 400;
    }
  }
</style>



// WEBPACK FOOTER //
// LoadingScreen.vue?a80c6be6